import { camelCase, startCase } from 'lodash';

import {
  ForbearanceWorkoutPlan,
  LoanReportingWorkoutPlanType,
  WorkoutPlanStatus,
  WorkoutPlanType,
} from '@willow/graphql-iso/src/app';

import { assertNever } from './assertNever';

export const formatWorkoutPlanType = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
    case WorkoutPlanType.PaymentDeferral:
      return 'Payment Deferral';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification Trial';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    case WorkoutPlanType.BankruptcyCh13:
      return 'Chapter 13 Bankruptcy';
    default:
      assertNever(type);
  }
};

export const formatLoanReportingWorkoutPlanType = (type: LoanReportingWorkoutPlanType) => {
  switch (type) {
    case LoanReportingWorkoutPlanType.None:
      return 'None';
    case LoanReportingWorkoutPlanType.PaymentDeferralOffered:
      return 'Deferral (offered)';
    case LoanReportingWorkoutPlanType.PaymentDeferment:
    case LoanReportingWorkoutPlanType.PaymentDeferral:
      return 'Deferral';
    case LoanReportingWorkoutPlanType.Forbearance:
      return 'Forbearance';
    case LoanReportingWorkoutPlanType.FlexModification:
      return 'Flex Modification Trial';
    case LoanReportingWorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    case LoanReportingWorkoutPlanType.BankruptcyCh_13:
      return 'Chapter 13 Bankruptcy';
    default:
      assertNever(type);
  }
};

export const formatWorkoutPlanTypeShort = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
    case WorkoutPlanType.PaymentDeferral:
      return 'Deferral';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    case WorkoutPlanType.BankruptcyCh13:
      return 'Chapter 13 Bankruptcy';
    default:
      assertNever(type);
  }
};

/** Accepts any workout plan with a type field (e.g. GraphQL fragments or types-iso plans). */
export const getWorkoutPlanTypeLabel = (
  plan: { type: WorkoutPlanType } & Partial<Pick<ForbearanceWorkoutPlan, 'forbearanceType'>>,
  isShort: boolean,
) => {
  switch (plan.type) {
    case WorkoutPlanType.Forbearance:
      return `${startCase(camelCase((plan as ForbearanceWorkoutPlan).forbearanceType))} Forbearance`;
    case WorkoutPlanType.PaymentDeferment:
    case WorkoutPlanType.PaymentDeferral:
    case WorkoutPlanType.FlexModification:
    case WorkoutPlanType.RepaymentPlan:
    case WorkoutPlanType.BankruptcyCh13:
      return isShort ? formatWorkoutPlanTypeShort(plan.type) : formatWorkoutPlanType(plan.type);
    default:
      assertNever(plan.type);
  }
};

export const formatWorkoutPlanStatusLabel = (status: WorkoutPlanStatus) => {
  return startCase(camelCase(status));
};
